<template xmlns="http://www.w3.org/1999/html">
    <div class="row">
        <div class="col-md-12" style="display: inline-flex;">
            <div class="col-md-3 pl-0">
                <label class="form-control-label" style="padding-top: 7px;">Search Calculations variable</label>
            </div>
            <div class="col-md-6 pl-0">
                <input v-model="search_calculations_variable" class="form-control" type="search"/>
            </div>
        </div>
        <div class="col-md-6">
            <table class="table table-bordered table-condensed mt-1">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Value</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="calculation_variable in first_calculations_variables_table">
                        <td>{{calculation_variable.name}}</td>
                        <td>{{calculation_variable.value}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="second_table" class="col-md-6">
            <table class="table table-bordered table-condensed mt-1">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Value</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="calculation_variable in second_calculations_variables_table">
                    <td>{{calculation_variable.name}}</td>
                    <td>{{calculation_variable.value}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'CalculationsVariables',
  data() {
    return {
      search_calculations_variable: '',
      timeout_id: '',
      first_calculations_variables_table: [],
      second_calculations_variables_table: [],
      second_table: false,
      calculations_variables: [
        {
          name: '[[calc_full_table]]',
          value: 'Calculations full table'
        },
        {
          name: '[[calc_short_table]]',
          value: 'Calculations short table'
        },
        {
          name: '[[acceptance_act_table]]',
          value: 'Acceptance act table'
        },
        {
          name: '[[first_data_acceptance_act_table]]',
          value: 'First data acceptance act table'
        },
        {
          name: '[[price_without_vat]]',
          value: 'Price without VAT'
        },
        {
          name: '[[price_without_vat_to_words]]',
          value: 'Price without VAT to words'
        },
        {
          name: '[[price_with_vat]]',
          value: 'Price with VAT'
        },
        {
          name: '[[price_with_vat_to_words]]',
          value: 'Price with VAT to words'
        },
        {
          name: '[[vat]]',
          value: 'VAT'
        },
        {
          name: '[[vat_to_words]]',
          value: 'VAT to words'
        },
        {
          name: '[[calculations_work_summary]]',
          value: 'A summary of calculations work'
        },
        {
          name: '[[calculations_quantity_sum]]',
          value: 'Calculations quantity sum'
        },
        {
          name: '[[calculations_quantity_sum_words]]',
          value: 'Calculations quantity sum to words'
        },
        {
          name: '[[discount_percentage]]',
          value: 'Discount (X%)'
        },
        {
          name: '[[discount_amount]]',
          value: 'Discount amount'
        },
        {
          name: '[[price_without_vat_with_discount]]',
          value: 'Price with discount (without VAT)'
        },
        {
          name: '[[paid_advance_payment_without_vat]]',
          value: 'Advance payment amount that has been paid (without VAT)'
        },
        {
          name: '[[paid_advance_payment_vat]]',
          value: 'Paid advance payment VAT'
        },
        {
          name: '[[paid_advance_payment_with_vat]]',
          value: 'Advance payment amount that has been paid (with VAT)'
        },
        {
          name: '[[total_balance]]',
          value: 'Total balance'
        },
        {
          name: '[[total_balance_to_words]]',
          value: 'Total balance to words'
        }
      ]
    };
  },
  watch: {
    search_calculations_variable: function (val) {
      this.first_calculations_variables_table = [];
      this.second_calculations_variables_table = [];
      this.second_table = false;
      const vm = this;
      if (vm.timeout_id) {
        clearTimeout(vm.timeout_id);
      }
      vm.timeout_id = setTimeout(() => {
        vm.searchCalculationsVariables(val);
      }, 1000);
    },
  },
  methods: {
    searchCalculationsVariables(value) {
      value = value.replace(/[\[\]]/g, '');
      if (!value) {
        return;
      }
      if (value == 'all') {
        this.second_table = true;
        var middle = Math.floor(this.calculations_variables.length / 2);
        this.first_calculations_variables_table = this.calculations_variables.slice(0, middle);
        this.second_calculations_variables_table = this.calculations_variables.slice(middle, this.calculations_variables.length);
      } else {
        const searched = [];
        for (const i in this.calculations_variables) {
          if (this.calculations_variables[i].name.search(value) != -1 || this.calculations_variables[i].value.search(value) != -1) {
            searched.push(this.calculations_variables[i]);
          }
        }
        if (searched.length > 8) {
          this.second_table = true;
          var middle = Math.floor(searched.length / 2);
          this.first_calculations_variables_table = searched.slice(0, middle);
          this.second_calculations_variables_table = searched.slice(middle, searched.length);
        } else {
          this.first_calculations_variables_table = searched;
        }
      }
    }
  },
  mounted() {
  },
};

</script>
